"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrantTypes = void 0;
const authz_1 = require("../../../codec/cosmos/authz/v1beta1/authz");
const tx_1 = require("../../../codec/cosmos/feegrant/v1beta1/tx");
const util_1 = require("../../../util");
const CarbonTx = __importStar(require("../../../util/tx"));
const utils_1 = require("../utils");
const TxTypes = {
    GrantAuthz: "cosmos-sdk/MsgGrant",
    GrantAllowance: "cosmos-sdk/MsgGrantAllowance",
    RevokeAuthz: "cosmos-sdk/MsgRevoke",
    RevokeFeegrant: "cosmos-sdk/MsgRevokeAllowance",
    MsgExec: "cosmos-sdk/MsgExec",
};
var GrantTypes;
(function (GrantTypes) {
    GrantTypes["GrantAuthz"] = "/cosmos.authz.v1beta1.MsgGrant";
    GrantTypes["RevokeAuthz"] = "/cosmos.authz.v1beta1.MsgRevoke";
    GrantTypes["FeeGrant"] = "/cosmos.feegrant.v1beta1.MsgGrantAllowance";
    GrantTypes["MsgExec"] = "/cosmos.authz.v1beta1.MsgExec";
    GrantTypes["GenericAuthorization"] = "/cosmos.authz.v1beta1.GenericAuthorization";
    GrantTypes["AllowedMsgAllowance"] = "/cosmos.feegrant.v1beta1.AllowedMsgAllowance";
    GrantTypes["BasicAllowance"] = "/cosmos.feegrant.v1beta1.BasicAllowance";
})(GrantTypes = exports.GrantTypes || (exports.GrantTypes = {}));
const ContentTypes = {
    [GrantTypes.GenericAuthorization]: "cosmos-sdk/GenericAuthorization",
    [GrantTypes.AllowedMsgAllowance]: "cosmos-sdk/AllowedMsgAllowance",
    [GrantTypes.BasicAllowance]: "cosmos-sdk/BasicAllowance",
};
const GenericAuthorizationAminoType = {
    aminoType: ContentTypes[GrantTypes.GenericAuthorization],
    valueMap: {},
};
const AllowedMsgAllowanceAminoType = {
    aminoType: ContentTypes[GrantTypes.AllowedMsgAllowance],
    valueMap: {},
};
const BasicAllowanceAminoType = {
    aminoType: ContentTypes[GrantTypes.BasicAllowance],
    valueMap: {
        expiration: utils_1.ConvertEncType.Date,
    },
};
const MsgGrantAuthz = {
    aminoType: TxTypes.GrantAuthz,
    valueMap: {
        grant: {
            expiration: utils_1.ConvertEncType.Date,
        },
    },
};
const MsgRevokeAuthz = {
    aminoType: TxTypes.RevokeAuthz,
    valueMap: {},
};
const MsgFeeGrantAllowance = {
    aminoType: TxTypes.GrantAllowance,
    valueMap: {},
};
const MsgRevokeAllowance = {
    aminoType: TxTypes.RevokeFeegrant,
    valueMap: {},
};
const MsgExec = {
    aminoType: TxTypes.MsgExec,
    valueMap: {},
};
const GenericAuthorizationAmino = {
    value: {
        msg: utils_1.ConvertEncType,
    },
};
const MsgFeeGrantAllowanceAmino = {
    value: {
        msg: utils_1.ConvertEncType,
    },
};
const preProcessAmino = (value, valueMap) => {
    return (0, utils_1.mapEachIndiv)(value, valueMap, false);
};
const checkDecodeGrantAuthz = (content, amino) => {
    const decodedValue = util_1.GrantUtils.decodeContent(content);
    const newContent = {
        type: ContentTypes[content.typeUrl],
        value: decodedValue.value,
    };
    const newAmino = Object.assign({}, amino);
    newAmino.content = Object.assign({}, GenericAuthorizationAmino.value);
    return {
        newContent,
        newAmino,
    };
};
const checkEncodeGrantAuthz = (content, amino) => {
    const grantAuthzMsg = preProcessAmino(content.value, GenericAuthorizationAmino.value.msg);
    const grantAuthzProp = authz_1.GenericAuthorization.fromPartial(Object.assign(Object.assign({}, content.value), { msg: grantAuthzMsg }));
    return {
        newContent: {
            typeUrl: GrantTypes.GenericAuthorization,
            value: authz_1.GenericAuthorization.encode(grantAuthzProp).finish(),
        },
        newAmino: Object.assign({}, amino),
    };
};
const grantAuthzAminoProcess = {
    toAminoProcess: (amino, input) => {
        const { grant } = input;
        const propResponse = checkDecodeGrantAuthz(grant === null || grant === void 0 ? void 0 : grant.authorization, amino);
        return {
            amino: propResponse.newAmino,
            input: Object.assign(Object.assign({}, input), { grant: Object.assign(Object.assign({}, grant), { authorization: propResponse.newContent }) }),
        };
    },
    fromAminoProcess: (amino, input) => {
        const { grant } = input;
        const propResponse = checkEncodeGrantAuthz(grant === null || grant === void 0 ? void 0 : grant.authorization, amino);
        return Object.assign(Object.assign({ amino: propResponse.newAmino }, input), { grant: Object.assign(Object.assign({}, grant), { authorization: propResponse.newContent }) });
    },
};
const checkEncodeFeegrant = (content, amino) => {
    const msg = preProcessAmino(content.value, MsgFeeGrantAllowanceAmino.value.msg);
    const grantAllowance = tx_1.MsgGrantAllowance.fromPartial(Object.assign(Object.assign({}, content.value), { msg }));
    const newContent = {
        typeUrl: GrantTypes.FeeGrant,
        value: tx_1.MsgGrantAllowance.encode(grantAllowance).finish(),
    };
    const newAmino = Object.assign({}, amino);
    return {
        newContent,
        newAmino,
    };
};
const checkDecodeFeegrant = (content, amino) => {
    const decodedValue = util_1.GrantUtils.decodeContent(content);
    decodedValue.value.allowance = {
        type: ContentTypes[decodedValue.value.allowance.typeUrl],
        value: decodedValue.value.allowance.value,
    };
    const newContent = {
        type: ContentTypes[content.typeUrl],
        value: decodedValue.value,
    };
    const newAmino = Object.assign({}, amino);
    newAmino.content = Object.assign({}, MsgFeeGrantAllowanceAmino.value);
    return {
        newContent,
        newAmino,
    };
};
const feegrantAminoProcess = {
    toAminoProcess: (amino, input) => {
        const { allowance } = input;
        const propResponse = checkDecodeFeegrant(allowance, amino);
        return {
            amino: propResponse.newAmino,
            input: Object.assign(Object.assign({}, input), { allowance: propResponse.newContent }),
        };
    },
    fromAminoProcess: (amino, input) => {
        const { allowance } = input;
        const propResponse = checkEncodeFeegrant(allowance, amino);
        return {
            amino: propResponse.newAmino,
            input: Object.assign(Object.assign({}, input), { allowance: propResponse.newContent }),
        };
    },
};
const GrantAmino = {
    [CarbonTx.Types.MsgGrant]: (0, utils_1.generateAminoType)(MsgGrantAuthz, grantAuthzAminoProcess),
    [CarbonTx.Types.MsgRevoke]: (0, utils_1.generateAminoType)(MsgRevokeAuthz),
    [CarbonTx.Types.MsgGrantAllowance]: (0, utils_1.generateAminoType)(MsgFeeGrantAllowance, feegrantAminoProcess),
    [CarbonTx.Types.MsgRevokeAllowance]: (0, utils_1.generateAminoType)(MsgRevokeAllowance),
    [CarbonTx.Types.MsgExec]: (0, utils_1.generateAminoType)(MsgExec),
    [GrantTypes.GenericAuthorization]: (0, utils_1.generateAminoType)(GenericAuthorizationAminoType),
    [GrantTypes.AllowedMsgAllowance]: (0, utils_1.generateAminoType)(AllowedMsgAllowanceAminoType),
    [GrantTypes.BasicAllowance]: (0, utils_1.generateAminoType)(BasicAllowanceAminoType),
};
exports.default = GrantAmino;
